import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../components/Logo';

const T = {
  night:'#0A1F3D', royal:'#1263B0', cyan:'#1CBCD3',
  gold:'#C9922A', goldL:'#FBF4E8', white:'#fff',
  cyanL:'#E0F7FA',
};

export default function Home() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith('en') ? 'en' : 'fr';

  const changeLang = (l) => {
    i18n.changeLanguage(l);
    localStorage.setItem('returnob_lang', l);
  };

  return (
    <div style={{ minHeight:'100vh', fontFamily:"'DM Sans',sans-serif" }}>

      {/* HERO */}
      <div style={{ background:`linear-gradient(160deg,${T.night} 0%,${T.royal} 60%,${T.cyan} 100%)`,
        position:'relative', overflow:'hidden', paddingBottom:'80px' }}>

        {/* NAVBAR */}
        <div style={{ maxWidth:'1100px', margin:'0 auto', padding:'24px 32px',
          display:'flex', alignItems:'center', justifyContent:'space-between',
          position:'relative', zIndex:10 }}>
          <Logo size='md' white />
          <div style={{ display:'flex', alignItems:'center', gap:'24px' }}>
            <div style={{ display:'flex', gap:'6px' }}>
              {['FR','EN'].map((l) => (
                <button key={l} onClick={() => changeLang(l.toLowerCase())}
                  style={{ fontSize:'12px', padding:'3px 10px', borderRadius:'6px',
                    background: lang===l.toLowerCase() ? 'rgba(255,255,255,0.2)' : 'transparent',
                    color: lang===l.toLowerCase() ? T.white : 'rgba(255,255,255,0.5)',
                    fontWeight: lang===l.toLowerCase() ? 700 : 400,
                    border: lang===l.toLowerCase() ? '1px solid rgba(255,255,255,0.3)' : '1px solid rgba(255,255,255,0.2)',
                    cursor:'pointer' }}>{l}</button>
              ))}
            </div>
            <Link to='/login'
              style={{ color:T.white, textDecoration:'none', fontSize:'14px', fontWeight:600,
                padding:'8px 18px', borderRadius:'10px', border:'1.5px solid rgba(255,255,255,0.4)' }}>
              {t('nav.login')}
            </Link>
            <Link to='/register'
              style={{ background:T.white, color:T.royal, padding:'10px 20px',
                borderRadius:'12px', textDecoration:'none', fontSize:'14px', fontWeight:700 }}>
              {t('nav.register')}
            </Link>
          </div>
        </div>

        {/* HERO TEXT */}
        <div style={{ maxWidth:'1100px', margin:'60px auto 0', padding:'0 32px',
          position:'relative', zIndex:10 }}>
          <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:'52px', fontWeight:700,
            color:T.white, lineHeight:1.25, marginBottom:'20px', whiteSpace:'pre-line' }}>
            {t('home.hero_title')}
          </h1>
          <p style={{ color:'rgba(255,255,255,0.7)', fontSize:'18px', lineHeight:1.7, maxWidth:'560px' }}>
            {t('home.hero_subtitle')}
          </p>
        </div>
      </div>

      {/* CARDS */}
      <div style={{ background:'#F7F9FC', padding:'60px 32px' }}>
        <div style={{ maxWidth:'1100px', margin:'0 auto' }}>
          <p style={{ fontSize:'11px', fontWeight:700, color:'#94A3B8',
            textTransform:'uppercase', letterSpacing:'1.5px',
            textAlign:'center', marginBottom:'32px' }}>{t('home.what_to_do')}</p>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'24px', marginBottom:'48px' }}>

            {/* CARTE PERDU - BLEU */}
            <Link to='/declarer-perte' style={{ textDecoration:'none' }}>
              <div style={{ background:`linear-gradient(135deg,${T.royal},#0D4F8A)`,
                borderRadius:'20px', padding:'28px', cursor:'pointer', height:'100%',
                boxShadow:'0 6px 20px rgba(18,99,176,0.3)', transition:'transform 0.2s',
                display:'flex', flexDirection:'column' }}
              onMouseEnter={e=>e.currentTarget.style.transform='translateY(-4px)'}
              onMouseLeave={e=>e.currentTarget.style.transform='translateY(0)'}>
                <div style={{ fontSize:'36px', marginBottom:'16px' }}>📋</div>
                <h3 style={{ color:T.white, fontWeight:700, fontSize:'17px', marginBottom:'8px' }}>
                  {t('home.lost_title')}</h3>
                <p style={{ color:'rgba(255,255,255,0.7)', fontSize:'13px', lineHeight:1.6, flex:1 }}>
                  {t('home.lost_desc')}</p>
                <p style={{ color:'rgba(255,255,255,0.9)', fontSize:'13px', fontWeight:700, marginTop:'20px',
                  background:'rgba(255,255,255,0.15)', padding:'8px 14px', borderRadius:'8px',
                  display:'inline-block' }}>
                  {t('home.lost_cta')}</p>
              </div>
            </Link>

            {/* CARTE TROUVE - OR */}
            <Link to='/declarer-trouvaille' style={{ textDecoration:'none' }}>
              <div style={{ background:`linear-gradient(135deg,${T.gold},#A67820)`,
                borderRadius:'20px', padding:'28px', cursor:'pointer', height:'100%',
                boxShadow:'0 6px 20px rgba(201,146,42,0.3)', transition:'transform 0.2s',
                display:'flex', flexDirection:'column' }}
              onMouseEnter={e=>e.currentTarget.style.transform='translateY(-4px)'}
              onMouseLeave={e=>e.currentTarget.style.transform='translateY(0)'}>
                <div style={{ fontSize:'36px', marginBottom:'16px' }}>🎒</div>
                <h3 style={{ color:T.white, fontWeight:700, fontSize:'17px', marginBottom:'8px' }}>
                  {t('home.found_title')}</h3>
                <p style={{ color:'rgba(255,255,255,0.85)', fontSize:'13px', lineHeight:1.6, flex:1 }}>
                  {t('home.found_desc')}</p>
                <p style={{ color:'rgba(255,255,255,0.9)', fontSize:'13px', fontWeight:700, marginTop:'20px',
                  background:'rgba(255,255,255,0.15)', padding:'8px 14px', borderRadius:'8px',
                  display:'inline-block' }}>
                  {t('home.found_cta')}</p>
              </div>
            </Link>

            {/* CARTE SECURISER - CYAN */}
            <Link to='/certifier' style={{ textDecoration:'none' }}>
              <div style={{ background:`linear-gradient(135deg,${T.cyan},#0E8FA3)`,
                borderRadius:'20px', padding:'28px', cursor:'pointer', height:'100%',
                boxShadow:'0 6px 20px rgba(28,188,211,0.3)', transition:'transform 0.2s',
                display:'flex', flexDirection:'column' }}
              onMouseEnter={e=>e.currentTarget.style.transform='translateY(-4px)'}
              onMouseLeave={e=>e.currentTarget.style.transform='translateY(0)'}>
                <div style={{ fontSize:'36px', marginBottom:'16px' }}>📜</div>
                <h3 style={{ color:T.white, fontWeight:700, fontSize:'17px', marginBottom:'8px' }}>
                  {t('home.certify_title')}</h3>
                <p style={{ color:'rgba(255,255,255,0.85)', fontSize:'13px', lineHeight:1.6, flex:1 }}>
                  {t('home.certify_desc')}</p>
                <p style={{ color:'rgba(255,255,255,0.9)', fontSize:'13px', fontWeight:700, marginTop:'20px',
                  background:'rgba(255,255,255,0.15)', padding:'8px 14px', borderRadius:'8px',
                  display:'inline-block' }}>
                  {t('home.certify_cta')}</p>
              </div>
            </Link>
          </div>

          {/* CTA BAS */}
          <div style={{ textAlign:'center', marginBottom:'40px' }}>
            <Link to='/register'
              style={{ background:T.royal, color:T.white, padding:'16px 36px',
                borderRadius:'16px', textDecoration:'none', fontSize:'15px', fontWeight:700,
                marginRight:'16px', display:'inline-block',
                boxShadow:'0 6px 20px rgba(18,99,176,0.3)' }}>
              {t('nav.register')}
            </Link>
            <Link to='/login'
              style={{ background:T.white, color:T.royal, padding:'16px 36px',
                borderRadius:'16px', textDecoration:'none', fontSize:'15px', fontWeight:600,
                border:'2px solid ' + T.royal, display:'inline-block' }}>
              {t('nav.login')}
            </Link>
          </div>

          {/* FOOTER */}
          <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
            gap:'8px', color:'#94A3B8', fontSize:'13px' }}>
            <span>🔒</span>
            <span style={{ fontFamily:"'Playfair Display',serif", fontStyle:'italic' }}>
              {t('home.trust_label')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
